import React from "react";

import Table from "../../common/Table";
import RowPhoto from "../../common/TdImg";

import { Link } from "react-router-dom";

const PastBalanceList = ({ data, query }) => {
  const renderLink = (e) => {
    return (
      <Link
        to={`/mis/teachers/${e.teacher_id}/profile/salary?teacherName=${e.teacher_name}`}
      >
        {e.teacher_name}
      </Link>
    );
  };

  const columns = [
    { path: "id", label: "شماره" },
    {
      path: "photo",
      label: "عکس",
      content: ({ teacher_photo }) => <RowPhoto src={teacher_photo} />,
    },
    {
      path: "aria_id",
      label: "کد استاد",
    },
    {
      path: "teacher_name",
      label: "استاد",
      content: (e) => renderLink(e),
    },
    { path: "faculty", label: "پوهنحی" },
    { path: "opening_balance", label: "حساب قبلی" },

    { path: "paid", label: "پرداخت شده" },
    { path: "balance", label: "باقیمانده" },
  ];

  return <Table data={data} columns={columns} query={query} />;
};

export default PastBalanceList;
